import service from '@/utils/server';

const modName = '/md/trackMateriel/';
//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/trackMateriel/api/index.js